import 'vuetify/dist/vuetify.min.css';
require("vue-swipe/dist/vue-swipe.css");

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index';

Vue.config.productionTip = false


import VueRx from 'vue-rx';
import VueI18n from 'vue-i18n';
import Vuetify from 'vuetify';

import { i18n } from './i18n/index';

import './icons/font-awesome';
import { RegiserGlobalComponents } from './global';
import { DFTPlugin } from './i18n/formatter';
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import { DevUtilPlugin } from './global/dev-util';
// ? Using VueRX
Vue.use(VueRx);

RegiserGlobalComponents(Vue);

Vue.use(DFTPlugin(Vue));
Vue.use(DevUtilPlugin(Vue));
Vue.use(VueAddtohomescreen);

Vue.use(Vuetify, {
  iconfont: 'fa',
  theme: {
    primary: '#828282',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
// new Vue({
//   i18n,
//   el: '#app',
//   router,
//   store,
//   components: { App },
//   template: '<App/>',
// });


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')


// Element.closest() Polyfill

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}